export default __webpack_public_path__ + "media/test-management.51a655a230cfb944b5c94d7c1ff63d2e.svg";